import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Front',
      component: () => import('./views/Front.vue'),
      children: [
        {
          path: '/',
          name: 'Start',
          component: () => import('./views/pages/Start.vue'),
        },
        {
          path: '/way',
          name: 'Way',
          component: () => import('./views/pages/Way.vue'),
        },
        {
          path: '/simple',
          name: 'Simple',
          component: () => import('./views/pages/Simple.vue'),
        },
        {
          path: '/contest',
          name: 'Contest',
          component: () => import('./views/pages/Contest.vue'),
          meta: { requiresAuth: true },
        },
        {
          path: '/simple_end',
          name: 'Simple_End',
          component: () => import('./views/pages/Simple_End.vue'),
        },
        {
          path: '/contest_end',
          name: 'Contest_End',
          component: () => import('./views/pages/Contest_End.vue'),
        },
        {
          path: '/message',
          name: 'Message',
          component: () => import('./views/pages/Message.vue'),
        },
        {
          path: '/personal',
          name: 'Personal',
          component: () => import('./views/pages/Personal.vue'),
          meta: { requiresAuth: true },
        },
        {
          path: '/ranking',
          name: 'Ranking',
          component: () => import('./views/pages/Ranking.vue'),
        },
      ],
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('./views/pages/Login.vue'),
    },
  ],
});
